var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiamond1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 763,
    height: 635,
    viewBox: "0 0 763 635",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.5 367.2L28.3 446.9L109.6 537.2L381.3 634.3L167.5 367.2Z",
    fill: "#17B7E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3 446.9L132.1 476.1L167.5 367.2L28.3 446.9Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.6 537.2L132.1 476.1L381.3 634.3L109.6 537.2Z",
    fill: "#F494B2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M213.3 123.5L0 35.8999L26 303.8L125.3 391.4L127.6 373.8L381.3 608.6L213.3 123.5Z",
    fill: "#17B7E2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 35.8999L150.9 373.1L125.3 391.4L93.2 409.8L26 303.8L0 35.8999Z",
    fill: "#5DDFF4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M595.1 367.2L734.3 446.9L653 537.2L381.3 634.3L595.1 367.2Z",
    fill: "#126D96"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M653 537.2L630.4 476L381.3 634.3L653 537.2Z",
    fill: "#17B7E2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M549.3 123.5L762.6 35.8999L736.7 303.8L381.3 608.6L549.3 123.5Z",
    fill: "#F494B2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M762.6 35.8999L584.2 434.6L669.4 409.8L736.7 303.8L762.6 35.8999Z",
    fill: "#126D96"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M734.3 446.9L630.5 476.1L604.6 397.7L637.3 391.4L734.3 446.9Z",
    fill: "#5DDFF4"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M132.1 476.1L106.7 158.9L381.3 0.300049L656 158.9L630.5 476.1L381.3 634.5L132.1 476.1Z",
    fill: "#5DDFF4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M132.1 476.1L106.7 158.9L381.3 0.300049L656 158.9L630.5 476.1L381.3 634.5L132.1 476.1Z",
    fill: "#5DDFF4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M381.3 317.5V634.3L630.5 476.1L381.3 317.5Z",
    fill: "#126D96"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M381.3 317.5L132.1 476.1L381.3 634.3V317.5Z",
    fill: "#17B7E2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M656 158.9L381.3 317.5L630.5 476.1L656 158.9Z",
    fill: "#17B7E2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M762.6 35.8999L575.6 112.7L381.3 0.5V317.5L655.8 159L656 158.9L762.6 35.8999Z",
    fill: "#5DDFF4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M381.3 317.5L106.7 158.9L132.1 476.1L381.3 317.5Z",
    fill: "#5DDFF4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M106.8 159L381.3 317.5V0.5L186.9 112.7L0 35.8999L106.7 158.9L106.8 159Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M558.1 197.6L430.5 123.9C415.6 115.3 398.6 110.7 381.4 110.7C364.2 110.7 347.2 115.3 332.3 123.9L204.7 197.6C194.7 203.4 188.5 214.1 188.5 225.6V297.1C188.5 322.7 199 347.2 217.3 364.9V370.1C217.3 406.6 236.9 440.6 268.4 458.8L381.4 524.1L494.4 458.8C526.8 440.1 544.9 406.8 545.5 364.9C563.9 347.1 574.3 322.7 574.3 297.1V225.6C574.3 214.1 568.1 203.4 558.1 197.6Z",
    fill: "#1C1128"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M249.8 215.3L381.3 291.2L512.8 215.3L411.4 156.8C392.7 146 369.8 146 351.1 156.8L249.8 215.3Z",
    fill: "#698445"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M381.3 323.4L226.3 236.2V297.1C226.3 317.2 237 335.8 254.4 345.8L255.1 346.2V370.1C255.1 393.2 267.3 414.4 287.2 425.9L381.2 480.2L475.2 425.9C495.1 414.4 507.3 393.2 507.3 362.9V346.2L508 345.8C525.4 335.7 536.1 317.2 536.1 297.1V236.2L381.3 323.4Z",
    fill: "#342A44"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M411.5 156.8C402.2 151.4 391.8 148.7 381.4 148.7V291.3L512.9 215.4L411.5 156.8Z",
    fill: "#1F4927"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M381.3 236.2L255.1 218.4L381.3 291.3L507.5 218.4L381.3 236.2Z",
    fill: "#143321"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M381.3 158.7C390.1 158.7 398.8 161 406.4 165.4L492.8 215.3L381.3 279.7L269.8 215.3L356.2 165.4C363.8 161.1 372.5 158.7 381.3 158.7ZM381.3 148.7C370.9 148.7 360.5 151.4 351.2 156.8L249.8 215.3L381.3 291.2L512.8 215.3L411.4 156.8C402.1 151.4 391.7 148.7 381.3 148.7Z",
    fill: "#2B5E36"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M236.4 253.3L376.5 332.1L381.4 334.9L386.3 332.1L526.4 253.3V297.1C526.4 313.6 517.5 328.9 503.3 337.2L502.6 337.6L497.6 340.5V346.3V363C497.6 388.3 488.2 407.1 470.5 417.3L381.5 468.7L292.5 417.3C275.8 407.7 265.4 389.6 265.4 370.2V346.3V340.5L260.4 337.6L259.7 337.2C245.4 329 236.6 313.6 236.6 297.1V253.3H236.4ZM536.3 236.2L381.3 323.4L226.3 236.2V297.1C226.3 317.2 237 335.8 254.4 345.8L255.1 346.2V370.1C255.1 393.2 267.3 414.4 287.2 425.9L381.2 480.2L475.2 425.9C495.1 414.4 507.3 393.2 507.3 362.9V346.2L508 345.8C525.4 335.7 536.1 317.2 536.1 297.1V236.2H536.3Z",
    fill: "#443B59"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M381.3 110.7C398.5 110.7 415.5 115.3 430.4 123.9L558 197.6C568 203.4 574.2 214.1 574.2 225.6V297.1C574.2 322.7 563.7 347.2 545.4 364.9C544.8 406.8 526.8 440.1 494.3 458.8L381.3 524.1L268.3 458.8C236.8 440.6 217.2 406.6 217.2 370.1V364.9C198.8 347.1 188.4 322.7 188.4 297.1V225.6C188.4 214.1 194.6 203.3 204.6 197.6L332.2 123.9C347.1 115.3 364.1 110.7 381.3 110.7ZM381.3 100.7C362.3 100.7 343.6 105.7 327.2 115.2L199.6 188.9C186.5 196.4 178.4 210.5 178.4 225.6V297.1C178.4 323.8 188.9 349.7 207.2 369V370.1C207.2 410.2 228.7 447.5 263.3 467.4L376.3 532.7L381.3 535.6L386.3 532.7L499.3 467.4C533.8 447.5 553.6 412.7 555.3 369.1C573.7 349.8 584.2 323.7 584.2 297V225.5C584.2 210.4 576.1 196.4 563 188.8L435.4 115.1C419 105.7 400.3 100.7 381.3 100.7Z",
    fill: "#17B7E2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M575.8 112.6L655.8 159L762.6 35.8999L575.8 112.6Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M381.3 11.8999L570.8 121.3L575.1 123.8L579.6 121.9L631.8 100.4L751 51.3999L726.9 300.4L661 404.4L655.4 413.2L664.5 418.4L718.6 449.4L647.3 528.6L381.4 623.7L115.5 528.6L44.2 449.4L98.3 418.4L107.4 413.2L101.8 404.4L35.9 300.5L11.8 51.5L21 55.3L183.3 121.9L187.8 123.8L192.1 121.3L381.3 11.8999ZM381.3 0.300049L186.8 112.6L24.5 46L0 35.8999L26 303.8L93.2 409.8L28.4 446.9L109.7 537.2L380.7 634.1L381.4 634.5L382.1 634.1L653.1 537.2L734.4 446.9L669.6 409.8L736.8 303.8L762.8 35.8999L628 91.2L575.8 112.7L381.3 0.300049Z",
    fill: "#17B7E2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M406.7 26.6001L536.3 101.4V89.8L410.5 17.2L406.7 26.6001Z",
    fill: "#5DDFF4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M732.6 241.8L726.9 300.5L681.4 372.2C685.2 372.4 689 372.7 692.8 372.9L736.6 303.8L742.2 246.3L732.6 241.8Z",
    fill: "#5DDFF4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2999 234.8L29.9999 241.4L21.4999 154.3L11.3999 153.4L19.2999 234.8Z",
    fill: "#5DDFF4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M159.8 555.1L173.8 549.5L115.4 528.6L80.4 489.8L69.5 492.6L109.6 537.2L159.8 555.1Z",
    fill: "#5DDFF4"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M586.9 560.8L587.3 550L427 607.4L436.1 614.7L586.9 560.8Z",
    fill: "#5DDFF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond1);
export default __webpack_public_path__ + "static/media/diamond-1.3758158f3ad9a215311e6eb2dc968226.svg";
export { ForwardRef as ReactComponent };